module.exports = __webpack_public_path__ + "static/media/Action-required-icon-2.df3186a5.png";